// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"9b2ac71c","453":"a9c20257"}[chunkId] + ".chunk.js";
};